import { useRef } from 'react';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { LANDING_PAGE_STATUS } from '../consts/landingPageStatus';

/**
 * Custom hook to track which version was initially published
 * This is used for both publish button logic and preview URL generation
 */
export const usePublishedVersionNumber = () => {
    const { value: status } = useFormFieldValue({ field: 'status' });
    const { value: versionNumber } = useFormFieldValue({ field: 'versionNumber' });

    // Capture which version was initially published (local UI logic)
    const initiallyPublishedVersionRef = useRef(null);

    // Capture the published version only once on initial load when status is PUBLISHED
    if (initiallyPublishedVersionRef.current === null && status === LANDING_PAGE_STATUS.PUBLISHED) {
        initiallyPublishedVersionRef.current = versionNumber;
    }

    return initiallyPublishedVersionRef.current;
};
